import {defineStore} from 'pinia'
import {http} from '@/extensions/http/index.js'
import {API_ENDPOINTS} from '@/config/index.js'

export const useUserStore = defineStore('user', {
    state: () => {
        return {
            all: null
        }
    },
    actions: {
        async init() {
            try {
                if (this.all) return

                const {data} = await http.get(API_ENDPOINTS.USER.INDEX)

                this.all = data
            } catch { /**/ }
        }
    }
})